import React from 'react';
import './DesktopElements.css';

const DesktopElements = () => {
  return (
    <div className="desktop-elements">
      <div className="window-outline window-1"></div>
      <div className="window-outline window-2"></div>
      <div className="window-outline window-3"></div>
      <div className="desktop-icon icon-1"></div>
      <div className="desktop-icon icon-2"></div>
      <div className="desktop-icon icon-3"></div>
      <div className="taskbar-hint"></div>
    </div>
  );
};

export default DesktopElements;